//built in libs
import { NgModule, Component, OnInit, Input, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SharedModule, UserSessionService, getDateObj } from '../../shared';
//services
import { PatientStopDeal, PatStopDealService } from './patient-stopdeal.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { SelectizeComponent } from '../../blocks/selectize/selectize.component';



@Component({
    selector: 'patStopDeal',
    templateUrl: './patient-stopdeal.component.html'
})

export class PatStopDealComponent implements OnInit {
    private ngUnsubscribe: Subject<void> = new Subject<void>();
    @ViewChild('selectize', { static: true }) _selectizeComponent: SelectizeComponent;

    PatStopDeal: PatientStopDeal = <PatientStopDeal>{};
    patCode: number;
    constructor(
        private _PatStopDealService: PatStopDealService,
        private _userSessionService: UserSessionService,

    ) { }

    ngOnInit() {
        // this.patCode = this._userSessionService.getSessionKey<number>('patientParms');

        this._userSessionService.subscribeToKey$('patientParms')
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((keys: any) => {
                if (keys.value) {
                    this.patCode = keys.value
                }
            });
    }

    addPatStopDeal() {
        this.PatStopDeal.startStopDeal = getDateObj(this.PatStopDeal.startStopDealNgb);
        this.PatStopDeal.endStopDeal = getDateObj(this.PatStopDeal.endStopDealNgb);
        delete this.PatStopDeal.startStopDealNgb;
        delete this.PatStopDeal.endStopDealNgb;

        this.PatStopDeal.regPatientMainDataCode = this.patCode;
        this._PatStopDealService.stopDealPatient(this.PatStopDeal)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(c => { },
                error => console.log(error),
                () => {
                    this._selectizeComponent.clear()
                    this.PatStopDeal = <PatientStopDeal>{};
                    this._userSessionService.closeModalKey('PatStopDealComponent', 'Cross click')
                    console.log('________Save Completed')
                })
    }
    ondateChange($event) {

    }
}

@NgModule({
    imports: [SharedModule],
    declarations: [PatStopDealComponent],
    providers: [PatStopDealService],
    exports: [PatStopDealComponent]
})

export class PatStopDealModule {

}


